import React from 'react';

import { GenericFooter } from '../LoginRouter/components/GenericFooter/GenericFooter';
import css from './Template.module.css';
import { Logo } from '../../layout/BotBuilderSidebar/Logo/Logo';

export const Template: React.FC = ({ children }) => {
  return (
    <div className={css.container}>
      <div className={css.header}>
        <Logo className={css.logo} href="/signup" />
      </div>
      {children}
      <GenericFooter />
    </div>
  );
};
